import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, input, OnDestroy, Output } from '@angular/core';

import { autocomplete, IAutoComplete } from '../../../controls/models/auto-complete.model';
import { TFormFieldSize } from '../../../controls/models/form-field-size';
import { SharedModule } from '../../../shared.module';
import { FormControl } from '@angular/forms';
import { SelectControlWithReadonlyComponent } from '../../../controls/container/select-control-with-readonly/select-control-with-readonly.component';
import { compareItems_dropdown } from 'src/app/infrastructure/services/list-services/_list-dropdown.service';

@Component({
    selector: 'app-tabs-dropdown',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './tabs-dropdown.component.html',
    styleUrls: ['./tabs-dropdown.component.scss'],
    standalone: true,
    imports: [
        SharedModule,
        SelectControlWithReadonlyComponent,
    ],
})
export class TabsDropdownComponent
    implements OnDestroy
{
    input_disabled$$ = input<boolean>(false, {alias: 'disabled'});
    input_classHeight$$ = input<TFormFieldSize>('def-height', {alias: 'classHeight'});
    input_list$$ = input<(IAutoComplete | null)[]>([], {alias: 'list'});
    input_value$$ = input<number | null>(null, {alias: 'value'});
    fieldName_value = autocomplete.itemId;

    // selectedValue$$ = computed<IAutoComplete>(() => {
    //     const _inputValue = this.inputValue$$();
    //     return this.inputList$$()?.find(item => item.itemId == _inputValue);
    // });
    compareWith: (o1: any, o2: any) => boolean = (o1, o2) => compareItems_dropdown(o1, o2);
    control = new FormControl<IAutoComplete | null>(null);
    control_displayValue: string | null = null;
    readonly$$ = computed<boolean>(() => this.input_list$$().length <= 1);

    constructor() {
        effect(() => {
            const _inputValue = this.input_value$$();
            const _inputList = this.input_list$$();
            const _selectedValue = _inputList?.find(item => !!item && item.itemId == _inputValue) ?? null;

            if (this.control.value?.itemId !== _selectedValue?.itemId) {
                this.control.setValue(_selectedValue, { emitEvent: false });
                this.control_displayValue = this.control.value?.[autocomplete.itemText] ?? null;
            }
        });
    }

    @Output() valueChangeEmit = new EventEmitter<number>();
    @Output() openedChangeEmit = new EventEmitter<boolean>();

    emit_valueChange(value: IAutoComplete) {
        this.valueChangeEmit.emit(value.itemId as number);
    }

    emit_openedChange(opened: boolean) {
        this.openedChangeEmit.emit(opened);
    }

    ngOnDestroy(): void {
        this.valueChangeEmit?.unsubscribe();
        this.openedChangeEmit?.unsubscribe();
    }
}
